<!-- Header -->
<app-outer-pages-header></app-outer-pages-header>

<!-- intro slider -->

<section class="intro-sec">
  <owl-carousel-o [options]="customOptions">
    <ng-template carouselSlide>
      <div class="slide">
       <div
        class="picsum-img-wrapper" 

        style="
          background-image: linear-gradient(
              rgba(9, 42, 30, 0.8),
              rgba(9, 42, 30, 0.8)
            ),
            url(../../assets/images/bann.png);
        "
      >
       
      </div>
        <div class="carousel-caption c2">
        <div class="container">
          <div class="text">
            <h1>المنصة العلاجية</h1>
            <p>وهى منصة تُعنى بعلاج اضطرابات التلعثم</p>
          </div>
          <a routerLink="/MedicalPlatform" class="btn btn-secondary">المزيد</a>
        </div>
      </div>
      </div>
    </ng-template>  
    <ng-template carouselSlide>
       <div class="slide">
          <div
        class="picsum-img-wrapper"
        style="
          background-image: linear-gradient(
              rgba(9, 42, 30, 0.8),
              rgba(9, 42, 30, 0.8)
            ),
            url(../../assets/images/banner2.jpg);
        "
      ></div>
      <div class="carousel-caption c1">
        <div class="container">
          <div class="text">
            <h1>المركز العلاجى</h1>
            <p>
              وهو مركز علاجى فى مدينة الرياض بالمملكة السعودية لعلاج اضطرابات
              التخاطب والسمع
            </p>
          </div>
          <a routerLink="/MedicalCenter" class="btn btn-secondary">المزيد</a>
        </div>
      </div>
       </div></ng-template>  
    <ng-template carouselSlide>
       <div class="slide">
         <div
        class="picsum-img-wrapper"
        style="
          background-image: linear-gradient(
              rgba(9, 42, 30, 0.8),
              rgba(9, 42, 30, 0.8)
            ),
            url(../../assets/images/b.png);
        "
      >
        <!-- <img
          src="../../../assets/images/Consultants.jpg"
          alt="Random third slide"
        /> -->
      </div>
      <div class="carousel-caption c3">
        <div class="container">
          <div class="text">
            <h1>خدمة مستشارك في التخاطب</h1>
            <p>
              وهى خدمة يتم من خلالها حجز موعد مع مختص فى التخاطب للاستشارة
              والتشخيص و الجلسات العلاجية
            </p>
          </div>
          <a class="btn btn-secondary" routerLink="/Consultant"> المزيد </a>
        </div>
      </div>
    </div>
  </ng-template>  
  </owl-carousel-o>
</section>


<!-- Our Services -->
<!-- <div class="OurServices site-services"> -->
<!-- <h3 class="text-center heading-title mb-4 text-site-color"><span class="font-weight-n"> عن</span> <span class="text-site-color-bright"> خدماتنا</span></h3> -->

<!-- <div class="container">
    <p class="font-size-lg text-muted mb-2">تتلخص خدماتنا فى التالى :</p>

    <ul
      class="w-list font-size-lg font-size-19 mb-0 text-muted d-flex flex-column gap-2"
    >
      <li>
        <a [routerLink]="['/MedicalPlatform']" class="text-site-color">
          1) المنصة العلاجية </a
        >( وهى منصة تُعنى بعلاج اضطرابات التلعثم ).
      </li>
      <li>
        <a [routerLink]="['/MedicalCenter']" class="text-site-color"
          >2) المركز العلاجي </a
        >( وهو مركز علاجى فى مدينة الرياض بالمملكة السعودية لعلاج اضطرابات
        التخاطب والسمع ).
      </li>
      <li>
        <a [routerLink]="['/Consultant']" class="text-site-color"
          >3) خدمة مستشارك للتخاطب </a
        >( وهى خدمة يتم من خلالها حجز موعد مع مختص فى التخاطب للاستشارة والتشخيص
        و الجلسات العلاجية ).
      </li>
    </ul>
  </div>

  <div class="container">
    <div class="row ServiceCollection space-around text-white g-24">
      <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="icon">
            <img
              src="assets/images/icons/stethoscope-icon.svg"
              alt="stethoscope icon"
            />
          </div>
          <div class="content">
            <h3 class="card-title limit-two">المنصة العلاجية</h3>
            <p class="card-desc limit-three">
              إلى جانب المركز العلاجي قامت الشركة بإنشاء (منصة علاجية ) يتم
              الوصول إليها من خلال موقع الكتروني، وتطبيق على الهواتف الذكية،
              تهدف إلى تشخيص التلعثم وعلاجه حاليا، وبعد ذلك نعتزم التوسع تدريجيا
              لتشمل المنصة علاج اضطرابات أخرى.
            </p>
          </div>
          <a href="/MedicalPlatform" class="btn btn-primary">المزيد</a>
        </div>
      </div>
      <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="icon">
            <img
              src="assets/images/icons/hospital-icon.svg"
              alt="hospital icon"
            />
          </div>
          <div class="content">
            <h3 class="card-title limit-two">المركز العلاجى</h3>
            <p class="card-desc limit-three">
              انبثق من الشركة (مركز سلاسة لعلاج اضطرابات التخاطب والسمع)، والذي
              بدأنا أعماله في مدينة الرياض، بالمملكة العربية السعودية. ويقوم على
              المركز مختصون في مجالي التخاطب والسمع. ونتطلع من تأسيس هذا المركز
              أن نقدم أفضل الخدمات التشخيصية والعلاجية.
            </p>
          </div>
          <a href="/MedicalCenter" class="btn btn-primary">المزيد</a>
        </div>
      </div>
      <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="icon">
            <img src="assets/images/icons/doctor-icon.svg" alt="doctor icon" />
          </div>
          <div class="content">
            <h3 class="card-title limit-two">مستشارك في التخاطب</h3>
            <p class="card-desc limit-three">
              يتوافر لدينا نخبة من الاخصائييين والاستشاريين المتميزين في مجال
              أمراض التخاطب والسمع من جنسيات مختلفة لتقديم خدمة مستشارك في
              التخاطب عبر موقعنا الاليكتروني أو من خلال تطبيق الجوال .
            </p>
          </div>
          <a href="/Consultant" class="btn btn-primary">المزيد</a>
        </div>
      </div> -->

<!-- <div
        class="w-32 w-all service bg-site-color py-5 border-left-1 pr-0 mb-2"
      >
        <a href="/MedicalPlatform">
          <div class="w-backgorund">
            <div class="icon-container flex justfy-center pb-4">
              <div class="index-img-container">
                <img
                  src="../../../assets/images/health-check.png"
                  class="index-img"
                />
              </div>
            </div>
            <h3 class="text-center bold font-size-22">المنصة العلاجية</h3>
          </div>

          <div class="w-overlay">
            <p
              class="pt-4 pb-1 px-3 text-center font-size-18 mb-0"
              style="line-height: 2"
            >
              إلى جانب المركز العلاجي قامت الشركة بإنشاء (منصة علاجية ) يتم
              الوصول إليها من خلال موقع الكتروني، وتطبيق على الهواتف الذكية،
              تهدف إلى تشخيص التلعثم وعلاجه حاليا، وبعد ذلك نعتزم التوسع تدريجيا
              لتشمل المنصة علاج اضطرابات أخرى.
              <span
                class="text-center font-size-20"
                style="display: block; line-height: 2"
              >
                المزيد....
              </span>
            </p>
          </div>
        </a>
      </div>

      <div
        class="w-32 w-all service bg-site-color py-5 border-left-1 pr-0 mb-2"
      >
        <a href="/MedicalCenter">
          <div class="w-backgorund">
            <div class="icon-container flex justfy-center pb-4">
              <div class="index-img-container">
                <img
                  src="../../../assets/images/Hospital-Clipart.png"
                  class="index-img"
                />
              </div>
            </div>
            <h3 class="text-center bold font-size-22">المركز العلاجى</h3>
          </div>

          <div class="w-overlay">
            <p
              class="pt-4 pb-1 px-3 text-center font-size-18 mb-0"
              style="line-height: 2"
            >
              انبثق من الشركة (مركز حلول التواصل لعلاج اضطرابات التخاطب والسمع)،
              والذي بدأنا أعماله في مدينة أبها، بالمملكة العربية السعودية. ويقوم
              على المركز مختصون في مجالي التخاطب والسمع. ونتطلع من تأسيس هذا
              المركز أن نقدم أفضل الخدمات التشخيصية والعلاجية.
              <span
                class="text-center font-size-20"
                style="display: block; line-height: 2"
              >
                المزيد....
              </span>
            </p>
          </div>
        </a>
      </div>

      <div
        class="w-32 w-all service bg-site-color py-5 border-left-1 pr-0 mb-2"
      >
        <a href="/Consultant">
          <div class="w-backgorund">
            <div class="icon-container flex justfy-center pb-4">
              <div class="index-img-container">
                <img
                  src="../../../assets/images/doctors.png"
                  class="index-img"
                />
              </div>
            </div>
            <h3 class="text-center bold font-size-22">مستشارك في التخاطب</h3>
          </div>

          <div class="w-overlay">
            <p
              class="pt-4 pb-1 px-3 text-center font-size-18 mb-0"
              style="line-height: 2"
            >
              يتوافر لدينا نخبة من الاخصائييين والاستشاريين المتميزين في مجال
              أمراض التخاطب والسمع من جنسيات مختلفة لتقديم خدمة مستشارك في
              التخاطب عبر موقعنا الاليكتروني أو من خلال تطبيق الجوال .
              <span
                class="text-center font-size-20"
                style="display: block; line-height: 2"
              >
                المزيد....
              </span>
            </p>
          </div>
        </a>
      </div> -->
<!-- </div>
  </div>
</div> -->

<!-- moving news -->
<!-- <div
  class="bg-text-site-color text-white font-size-20 pt-3 pb-2 px-2"
  style="direction: ltr"
>
  <marquee
    direction="right"
    behavior="scroll"
    onmouseover="this.stop();"
    onmouseout="this.start();"
  >
    <a
      class="text-white"
      target="_blank"
      href="NewsDetails/{{ specialNews.id }}"
      >.{{ specialNews.title }}</a
    >
  </marquee>
</div> -->

<!-- welcome -->
<div class="container">
  <div class="welcom-sec">
    <div class="row g-24">
      <div class="col-12">
        <div class="section-title">
          <h2>مرحبا بكم</h2>
          <p>
            تتشرف شركة سلاسة بتقديم خدماتها لكم في هذا
            <a href="/AboutUs" class="text-site-color"
              >(الموقع للمزيد عن الشركة وخدماتها)</a
            >
            , ومن خلال التطبيق المصاحب له
            <a href="#" target="_blank" class="text-site-color"
              >(اضغط هنا لتحميل التطبيق)</a
            >
            وذلك لمن يحتاجون إلى تشخيص وعلاج اضطرابات التخاطب والسمع. ويتم تقديم
            الخدمات من خلال ثلاث وسائل وهي :
          </p>
        </div>
      </div>

      <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="icon">
            <img
              src="assets/images/icons/stethoscope-icon.svg"
              alt="stethoscope icon"
            />
          </div>
          <div class="content">
            <h3 class="card-title limit-two">المنصة العلاجية</h3>
            <p class="card-desc limit-three">
              التشخيص والعلاج بشكل آلي مع المتابعة و المراقبة و ذلك لاضطرابات
              التلعثم حاليا و مستقبلا ستتم إضافة علاج اضطرابات أخرى من خلال
              المنصة العلاجية دون الحاجة لحضورك
            </p>
          </div>
          <a href="/MedicalPlatform" class="btn btn-primary">المزيد</a>
        </div>
      </div>

      <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="icon">
            <img
              src="assets/images/icons/hospital-icon.svg"
              alt="hospital icon"
            />
          </div>
          <div class="content">
            <h3 class="card-title limit-two">المركز العلاجى</h3>
            <p class="card-desc limit-three">
              التشخيص والعلاج والمتابعة من خلال حضورك إلى المركز العلاجي الواقع
              في مدينة الرياض بالمملكة العربية السعودية بالعنوان الموضح ادنى
              الصفحة
            </p>
          </div>
          <a href="/MedicalCenter" class="btn btn-primary">المزيد</a>
        </div>
      </div>

      <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="icon">
            <img src="assets/images/icons/doctor-icon.svg" alt="doctor icon" />
          </div>
          <div class="content">
            <h3 class="card-title limit-two">مستشارك في التخاطب</h3>
            <p class="card-desc limit-three">
              التشخيص والعلاج من خلال خدمة مستشارك في التخاطب والتي يمكنك من
              خلالها حجز موعد مع المختص المناسب لك للقيام بالتشخيص والعلاج دون
              الحاجة لحضورك
            </p>
          </div>
          <a href="/Consultant" class="btn btn-primary">المزيد</a>
        </div>
      </div>

      <!-- <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="content">
            <h3 class="card-title limit-two">الوسيلة الأولى</h3>
            <p class="card-desc limit-three">
              التشخيص والعلاج والمتابعة من خلال حضورك إلى المركز العلاجي الواقع
              في مدينة الرياض بالمملكة العربية السعودية بالعنوان الموضح ادنى
              الصفحة
            </p>
          </div>
          <a href="/MedicalCenter" class="btn btn-primary">المزيد</a>
        </div>
      </div> -->

      <!-- <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="content">
            <h3 class="card-title limit-two">الوسيلة الثانية</h3>
            <p class="card-desc limit-three">
              التشخيص والعلاج من خلال خدمة مستشارك في التخاطب والتي يمكنك من
              خلالها حجز موعد مع المختص المناسب لك للقيام بالتشخيص والعلاج دون
              الحاجة لحضورك
            </p>
          </div>
          <a href="/Sas/ConsultantPlatform" class="btn btn-primary">المزيد</a>
        </div>
      </div> -->

      <!-- <div class="col-md-4">
        <div class="service-single card-light-border">
          <div class="content">
            <h3 class="card-title limit-two">الوسيلة الثالثة</h3>
            <p class="card-desc limit-three">
              التشخيص والعلاج بشكل آلي مع المتابعة و المراقبة و ذلك لاضطرابات
              التلعثم حاليا و مستقبلا ستتم إضافة علاج اضطرابات أخرى من خلال
              المنصة العلاجية دون الحاجة لحضورك
            </p>
          </div>
          <a href="/MedicalPlatform" class="btn btn-primary">المزيد</a>
        </div>
      </div> -->

      <!-- <div class="col-lg-4">
        <div class="row my-4">
          <div class="col-lg-6">
            <img
              src=".././../../assets/images/woman-teaches-kid.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
          <div class="col-lg-6">
            <img
              src=".././../../assets/images/woman-teaches-kid_2.jpg"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <img
              src=".././../../assets/images/woman-teaches-kid_3.png"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
          <div class="col-lg-6">
            <img
              src=".././../../assets/images/woman-teaches-kid_4.png"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
        </div>
      </div> -->

      <!-- <div class="col-lg-8 mt-4"> -->
      <!-- <h3 class="heading-title mb-4 text-site-color">مرحبا بكم ...</h3> -->
      <!-- <p class="font-size-lg text-muted">
          تتشرف شركة حلول التواصل الطبية بتقديم خدماتها لكم في هذا
          <a href="/AboutUs" class="text-site-color"
            >(الموقع للمزيد عن الشركة وخدماتها)</a
          >
          , ومن خلال التطبيق المصاحب له
          <a
            href="https://play.google.com/store/apps/details?id=com.cptit.tal3thoom"
            target="_blank"
            class="text-site-color"
            >(اضغط هنا لتحميل التطبيق)</a
          >
          وذلك لمن يحتاجون إلى تشخيص وعلاج اضطرابات التخاطب والسمع. ويتم تقديم
          الخدمات من خلال ثلاث وسائل وهي :
        </p>

        <div class="row space-between">
          <div class="col-lg-4 col-md-5 col-sm-12">
            <h4 class="text-center text-site-color bold">الوسيلة الأولى</h4>
            <p>
              التشخيص والعلاج والمتابعة من خلال حضورك إلى المركز العلاجي الواقع
              في مدينة أبها بالمملكة العربية السعودية بالعنوان الموضح ادنى
              الصفحة
              <a href="/MedicalCenter" class="text-site-color"
                >(للمزيد عن المركز العلاجي)</a
              >.
            </p>
          </div>

          <div class="col-lg-4 col-md-5 col-sm-12">
            <h4 class="text-center text-site-color bold">الوسيلة الثانية</h4>
            <p>
              التشخيص والعلاج من خلال خدمة مستشارك في التخاطب والتي يمكنك من
              خلالها حجز موعد مع المختص المناسب لك للقيام بالتشخيص والعلاج دون
              الحاجة لحضورك
              <a href="/Sas/ConsultantPlatform" class="text-site-color"
                >(للمزيد عن خدمة مستشارك في التخاطب)</a
              >.
            </p>
          </div>

          <div class="col-lg-4 col-md-5 col-sm-12">
            <h4 class="text-center text-site-color bold">الوسيلة الثالثة</h4>
            <p>
              التشخيص والعلاج بشكل آلي مع المتابعة و المراقبة و ذلك لاضطرابات
              التلعثم حاليا و مستقبلا ستتم إضافة علاج اضطرابات أخرى من خلال
              المنصة العلاجية دون الحاجة لحضورك
              <a href="/MedicalPlatform" class="text-site-color"
                >(للمزيد عن المنصة العلاجية)</a
              >.
            </p>
          </div>
        </div>
      </div> -->

      <!-- video -->
      <!-- <div class="col-lg-3 my-3">
        <div class="video-default vd radius-10">
          <div class="video-container">
            <iframe class="radius-10" width="100%" height="300" src="https://www.youtube.com/embed/nTB61iR6cVQ" frameborder="0" allowfullscreen="allowfullscreen"></iframe>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>

<!-- Specialties -->
<div class="container">
  <div id="Specialties" class="Specialties">
    <!-- <h3 class="text-center heading-title mb-4 text-site-color borderAfter">
      التخصصات
    </h3> -->

    <div class="section-title">
      <h2>التخصصات</h2>
    </div>

    <div class="row g-24 " style=" flex-direction: row-reverse;">
      <div
        class="col-lg-3 col-md-6"
        *ngFor="let mainSp of mainSpecialities; let i = index"
      >
        <div class="specialty-single card-light-border">
          <h3>{{ mainSp.title }}</h3>
          <div class="sub-titles">
            <a target="_blank" *ngFor="let subSp of mainSp.subSpecialities">{{
              subSp.title
            }}</a>
          </div>
        </div>
      </div>
    </div>

    <!-- dynamic main specialities -->
    <!-- <div class="row justify-content-around">
      <div
        class="col-lg-3 col-md-6 mb-4"
        *ngFor="let mainSp of mainSpecialities; let i = index"
      >
        <div class="box">
          <h6 class="text-center my-3 font-weight-b font-size-lg">
            {{ mainSp.title }}
          </h6> -->
    <!-- <a *ngFor="let subSp of mainSp.subSpecialities;" href="/Doctors/{{subSp.id}}" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">{{subSp.title}}</a> -->
    <!-- <a
            *ngFor="let subSp of mainSp.subSpecialities"
            target="_blank"
            class="text-center line-font font-weight-b text-site-color-bright"
            >{{ subSp.title }}</a
          >
        </div>
      </div>
    </div> -->

    <!-- static main specialities -->
    <!-- <div class="row justify-content-around pt-3">
      <div class="col-lg-3 col-md-6 mb-4">
        <div class="box">
          <h6 class="text-center my-3 font-weight-b font-size-lg">أمراض التخاطب</h6>
          <a href="/Doctors?subSpeciality=اضطرابات اللغة" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">اضطرابات اللغة</a>
          <a href="/Doctors?subSpeciality=اضطرابات الكلام" target="_blank"  class="text-center line-font font-weight-b text-site-color-bright">اضطرابات الكلام</a>
          <a href="/Doctors?subSpeciality=اضطرابات الصوت" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">اضطرابات الصوت</a>
          <a href="/Doctors?subSpeciality=اضطرابات البلع" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">اضطرابات البلع</a>
        </div>
      </div>

      <div class="col-lg-3 col-md-6  mb-4">
        <div class="box">
          <h6  class="text-center my-3 font-weight-b font-size-lg">أمراض السمع</h6>
          <a href="/Doctors?subSpeciality=التشخيص" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">التشخيص</a>
          <a href="/Doctors?subSpeciality=العلاج" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">العلاج</a>
          <a href="/Doctors?subSpeciality=زراعة القوقعة" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">زراعة القوقعة</a>
        </div>
      </div>

      <div class="col-lg-3 col-md-6  mb-4">
        <div class="box">
          <h6 class="text-center my-3 font-weight-b font-size-lg">الاستشارات النفسية والاجتماعية</h6>
          <a href="/Doctors?subSpeciality=التشخيص" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">التشخيص</a>
          <a href="/Doctors?subSpeciality=العلاج" target="_blank" class="text-center line-font font-weight-b text-site-color-bright">العلاج</a>
        </div>
      </div>
    </div> -->
  </div>
</div>

<!-- Doctors -->
<div class="container">
  <div class="Doctors">
    <!-- <h3 class="text-center heading-title mb-4 text-site-color borderAfter">
      الاخصائيين والاستشاريين العاملين معنا
    </h3> -->

    <div class="section-title">
      <h2>الاخصائيين والاستشاريين العاملين معنا</h2>
    </div>

    <div class="">
        <owl-carousel-o [options]="docOptions">
    <ng-template class="" carouselSlide    *ngFor="let item of doctors; let i = index">
        <div class="doctor-single card-light-border">
          <a href="DoctorProfile/{{ item.id }}" target="_blank">
            <div class="icon">
              <img
                [src]="DisplayedDoctorImage(item.pictureUrl)"
                class="img-fluid" style="object-fit: cover;"
              />
            </div>
            <h3>
              د. {{ item.firstName }} {{ item.midName }} {{ item.lastName }}
            </h3>
            <p>
              <span *ngIf="item.scientificDegree == 'MSc'"> أخصائى </span>
              <span *ngIf="item.scientificDegree == 'PSc'"> أخصائى أول </span>
              <span *ngIf="item.scientificDegree == 'PhD'"> استشارى </span>
            </p>
          </a>
        </div>
      </ng-template>
      </owl-carousel-o>
     

      <!-- ######### static ######### -->
      <!-- <div class="col-lg-3 col-md-6">
        <div class="doctor-single card-light-border">
          <a href="#" target="_blank">
            <div class="icon">
              <img
                src=".././../../assets/images/doctor.png"
                class="img-fluid"
              />
            </div>
            <h3>د. أحمد محمد علي</h3>
            <p>
              <span> أخصائى </span>
            </p>
          </a>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="doctor-single card-light-border">
          <a href="#" target="_blank">
            <div class="icon">
              <img
                src=".././../../assets/images/fspecialist.jpeg"
                class="img-fluid"
              />
            </div>
            <h3>د. ملك عبدالرحمن محمود</h3>
            <p>
              <span> أخصائى </span>
            </p>
          </a>
        </div>
      </div>
      <div class="col-lg-3 col-md-6">
        <div class="doctor-single card-light-border">
          <a href="#" target="_blank">
            <div class="icon">
              <img
                src=".././../../assets/images/doctor.png"
                class="img-fluid"
              />
            </div>
            <h3>د. حسن ابراهيم هشام</h3>
            <p>
              <span> استشارى </span>
            </p>
          </a>
        </div>
      </div> -->

      <!-- <div
        class="col-lg-2 col-md-6 mb-4"
        *ngFor="let item of doctors; let i = index"
      >
        <a href="DoctorProfile/{{ item.id }}" target="_blank">
          <div class="flex justfy-center"> -->
      <!-- <img src=".././../../assets/images/avatar2.jpg" class="img-fluid img-thumbnail-edit"> -->
      <!-- <img
              [src]="DisplayedDoctorImage(item.pictureUrl)"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
          <h6 class="text-center mt-2 mb-0 font-weight-b">
            د. {{ item.firstName }} {{ item.midName }} {{ item.lastName }}
          </h6>
          <h6 class="text-center text-site-color-bright">
            <span *ngIf="item.scientificDegree == 'MSc'"> أخصائى </span>
            <span *ngIf="item.scientificDegree == 'PSc'"> أخصائى أول </span>
            <span *ngIf="item.scientificDegree == 'PhD'"> استشارى </span>
          </h6>
        </a>
      </div> -->

      <!-- <div class="col-lg-2 col-md-6  mb-4">
        <div class="flex justfy-center">
          <img src=".././../../assets/images/fspecialist.jpeg" class="img-fluid img-thumbnail-edit">
        </div>
        <h6 class="text-center mt-2 mb-0 font-weight-b">د. ياسمين عبد الفتاح</h6>
        <h6 class="text-center text-site-color-bright">أخصائى تخاطب</h6>
      </div>

      <div class="col-lg-2 col-md-6  mb-4">
        <div class="flex justfy-center">
          <img src=".././../../assets/images/doctor.png" class="img-fluid img-thumbnail-edit">
        </div>
        <h6 class="text-center mt-2 mb-0 font-weight-b">د. علاء عبد الفتاح</h6>
        <h6 class="text-center text-site-color-bright">أخصائى تخاطب</h6>
      </div>

      <div class="col-lg-2 col-md-6  mb-4">
        <div class="flex justfy-center">
          <img src=".././../../assets/images/woman-doctor.jpg" class="img-fluid img-thumbnail-edit">
        </div>
        <h6 class="text-center mt-2 mb-0 font-weight-b">د. سارة عبد الفتاح</h6>
        <h6 class="text-center text-site-color-bright">أخصائى تخاطب</h6>
      </div>

      <div class="col-lg-2 col-md-6  mb-4">
        <div class="flex justfy-center">
          <img src=".././../../assets/images/saudi-avatar.jpg" class="img-fluid img-thumbnail-edit">
        </div>
        <h6 class="text-center mt-2 mb-0 font-weight-b">د. سعيد عبد الفتاح</h6>
        <h6 class="text-center text-site-color-bright">أخصائى تخاطب</h6>
      </div> -->
    </div>
  </div>
</div>

<!-- News -->
<div class="news-section">
  <div class="container">
    <div class="section-title">
      <h2>آخر الأخبار</h2>
    </div>

    <div class="">
      <!-- ######## dynamic ######## -->
        <owl-carousel-o [options]="newsOptions">
    <ng-template class="" carouselSlide    *ngFor="let item of news; let i = index">
       <div class="card-light-border news-single h-100">
          <div class="icon">
            <img
              [src]="DisplayedNewsImage(item.pictureUrl)"
              alt="image"
              class="img-fluid" style="object-fit: cover;"
            />
          </div>
          <div class="content">
            <h3 class="limit-two card-title">{{ item.title }}</h3>
            <p class="limit-three card-desc">
              لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت
              دو أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا .
              يوت انيم أد مينيم فينايم,كيواس نوستريد أكسير سيتاشن يللأمكو
              لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات .
            </p>
          </div>
          <a href="NewsDetails/{{ item.id }}" class="btn btn-primary"
            >قراءة المزيد</a
          >
        </div>
      </ng-template>
      </owl-carousel-o>
     

      <!-- ######## static ######## -->
      <!-- <div class="col-lg-4 col-md-6 col-12">
        <div class="card-light-border news-single">
          <div class="icon">
            <img
              src=".././../../assets/images/Arabic-mother-and-child-on-computer.jpg"
              alt="image"
              class="img-fluid"
            />
          </div>
          <div class="content">
            <h3 class="limit-two card-title">لوريم ايبسوم دولار سيت أميت</h3>
            <p class="limit-three card-desc">
              لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت
              دو أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا .
              يوت انيم أد مينيم فينايم,كيواس نوستريد أكسير سيتاشن يللأمكو
              لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات .
            </p>
          </div>
          <a href="NewsDetails" class="btn btn-primary">قراءة المزيد</a>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12">
        <div class="card-light-border news-single">
          <div class="icon">
            <img
              src=".././../../assets/images/Doctor-Examining-Child.jpg"
              alt="image"
              class="img-fluid"
            />
          </div>
          <div class="content">
            <h3 class="limit-two card-title">لوريم ايبسوم دولار سيت أميت</h3>
            <p class="limit-three card-desc">
              لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت
              دو أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا .
              يوت انيم أد مينيم فينايم,كيواس نوستريد أكسير سيتاشن يللأمكو
              لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات .
            </p>
          </div>
          <a href="NewsDetails" class="btn btn-primary">قراءة المزيد</a>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 col-12">
        <div class="card-light-border news-single">
          <div class="icon">
            <img
              src=".././../../assets/images/woman-teaches-kid_4.png"
              alt="image"
              class="img-fluid"
            />
          </div>
          <div class="content">
            <h3 class="limit-two card-title">لوريم ايبسوم دولار سيت أميت</h3>
            <p class="limit-three card-desc">
              لوريم ايبسوم دولار سيت أميت ,كونسيكتيتور أدايبا يسكينج أليايت,سيت
              دو أيوسمود تيمبور أنكايديديونتيوت لابوري ات دولار ماجنا أليكيوا .
              يوت انيم أد مينيم فينايم,كيواس نوستريد أكسير سيتاشن يللأمكو
              لابورأس نيسي يت أليكيوب أكس أيا كوممودو كونسيكيوات .
            </p>
          </div>
          <a href="NewsDetails" class="btn btn-primary">قراءة المزيد</a>
        </div>
      </div> -->
    </div>
  </div>
</div>
<!-- <div class="Testimonials text-white">
  <div class="background-image-edit"></div>

  <div class="all-t pb-4">
    <h3 class="text-center heading-title my-4">آخر الأخبار</h3> -->

<!-- carousel Testimonials -->
<!-- <ngb-carousel class="pt-3">

      <ng-template ngbSlide>

        <div class="col-lg-12">
          <div class="flex justfy-center">
            <img src=".././../../assets/images/avatar2.jpg" class="img-fluid img-thumbnail-edit">
          </div>
          <h4 class="text-center mt-4 pt-3 font-weight-b"><q> مركز مميز وله عشرين سنة في خدمة التخاطب </q></h4>
          <h5 class="text-center pb-4"> اسماعيل المطلق</h5>
        </div>

      </ng-template>

      <ng-template ngbSlide>
        <div class="col-lg-12">
          <div class="flex justfy-center">
            <img src=".././../../assets/images/doctor.png" class="img-fluid img-thumbnail-edit">
          </div>
          <h4 class="text-center mt-4 pt-3 font-weight-b"><q> يستخدم المختصون أفضل الطرق فى العلاج للوصول إلى أفضل النتائج </q></h4>
          <h5 class="text-center pb-4"> محمود المطلق</h5>
        </div>
      </ng-template>

      <ng-template ngbSlide>
        <div class="col-lg-12">
          <div class="flex justfy-center">
            <img src=".././../../assets/images/saudi-avatar.jpg" class="img-fluid img-thumbnail-edit">
          </div>
          <h4 class="text-center mt-4 pt-3 font-weight-b"><q> مركز مميز وله عشرين سنة في خدمة التخاطب </q></h4>
          <h5 class="text-center pb-4"> عبد السلام المطلق</h5>
        </div>
      </ng-template>

      <ng-template ngbSlide>
        <div class="col-lg-12">
          <div class="flex justfy-center">
            <img src=".././../../assets/images/fspecialist.jpeg" class="img-fluid img-thumbnail-edit">
          </div>
          <h4 class="text-center mt-4 pt-3 font-weight-b"><q> مركز مميز وله عشرين سنة في خدمة التخاطب </q></h4>
          <h5 class="text-center pb-4"> زياد المطلق</h5>
        </div>
      </ng-template>

    </ngb-carousel> -->

<!-- carousel News-->
<!-- <ngb-carousel class="pt-3">
      <ng-template ngbSlide *ngFor="let item of news; let i = index">
        <div class="col-lg-12">
          <div class="flex justfy-center">
            <img
              [src]="DisplayedNewsImage(item.pictureUrl)"
              class="img-fluid img-thumbnail-edit"
            />
          </div>
          <h4 class="text-center mt-4 pt-3 font-weight-b">
            <q> {{ item.title }} </q>
          </h4>
          <h5 class="text-center pb-4">
            <a
              class="text-white"
              href="NewsDetails/{{ item.id }}"
              target="_blank"
            >
              المزيد....
            </a>
          </h5>
        </div>
      </ng-template>
    </ngb-carousel>
  </div>
</div> -->

<!-- fixes news at bottom -->
<!-- <div
  id="fixedBottomNews"
  class="bg-text-site-color text-white font-size-20 py-3 px-3 text-center"
  style="
    width: 100%;
    right: 0;
    left: 0;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    z-index: 100;
  "
>
  <a class="text-white" target="_blank" href="NewsDetails/{{ specialNews.id }}"
    >{{ specialNews.title }}.</a
  >
  <span (click)="removeFixedNews()"
    ><i class="fas fa-times mt-1" style="float: left; cursor: pointer"></i
  ></span>
</div> -->

<!-- Footer -->
<app-outer-pages-footer></app-outer-pages-footer>
